import React from 'react';
import SearchForm from '../components/SearchForm';
import Cocktails from '../components/Cocktails';

const Home = () => {
    return (
        <div>
            <SearchForm/>
            <Cocktails/>
        </div>
    )
}

export default Home
